const DotIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="9" cy="9" r="4" fill="#D92D20" />
        </svg>
    );
};

export { DotIcon };